"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preventIOSOverScroll = void 0;
const preventIOSOverScroll = (ref) => {
    if (ref.current) {
        const scrollContainerElement = ref.current;
        const currentScrollPosition = scrollContainerElement.scrollTop;
        const totalScrollableHeight = scrollContainerElement.scrollHeight;
        const clientHeight = scrollContainerElement.clientHeight;
        if (currentScrollPosition <= 0) {
            scrollContainerElement.scrollTop = 1;
        }
        else if (currentScrollPosition + clientHeight >= totalScrollableHeight) {
            scrollContainerElement.scrollTop = totalScrollableHeight - clientHeight - 1;
        }
    }
};
exports.preventIOSOverScroll = preventIOSOverScroll;
